export default __webpack_public_path__ + "static/a920-41cb9376a2a452a085590ae74aaf7096.png";